export const convertDate = (formDateString: string): string => {
  const date = formDateString.replace(/\D/g, '');

  const year = date.slice(4);
  const day = date.slice(0, 2);
  const month = date.slice(2, 4);

  return `${year}-${month}-${day}`;
};
